<app-layout>
  <div class="main">
    <div class="header-table">
      <div class="title">
        <app-titulo>Transportadoras</app-titulo>
      </div>
      <div class="header-buttons">
        <app-botao
          type="primario"
          text="Nova Transportadora"
          icon="assets/add.svg"
          (click)="navegarCadastroTransportadora()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Transportadoras Cadastradas</div>
        <div class="align-button">
          <form [formGroup]="form">
            <div class="table-filters">
              <app-input
                label="Nome da Transportadora"
                width="100%"
                placeholder="Pesquisar"
                name="NM_TPTD"
                formControlName="NM_TPTD"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Nome da Transportadora"
        width="100%"
        placeholder="Pesquisar"
        name="NM_TPTD"
        formControlName="NM_TPTD"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true"></app-card>
  </div>
  <app-subtitulo *ngIf="!tableData.length && !isLoading"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
</app-layout>
